var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-lazy-image',{attrs:{"src":_vm.src,"src-placeholder":require('@/assets/images/spinner.svg')}})}
var staticRenderFns = []

export { render, staticRenderFns }